import { LazyErrorBoundary, LazyLoadingFallback, LazyLottie } from '@/lib/lazy-components'
import EmergenceLoader from '@/styles/animations/emergence-loader.json'
import type { LottieComponentProps } from 'lottie-light-react'
import React from 'react'

export const EmergenceAnimation = (props: Omit<LottieComponentProps, 'animationData' | 'ref'>) => (
  <LazyErrorBoundary>
    <React.Suspense fallback={<LazyLoadingFallback className='h-8 w-8' />}>
      <LazyLottie animationData={EmergenceLoader} {...props} />
    </React.Suspense>
  </LazyErrorBoundary>
)
